import { jsx as a } from "react/jsx-runtime";
import '../../assets/Tooltip.css';function r({ children: o, message: t, className: p = "" }) {
  return /* @__PURE__ */ a("span", { className: "tooltip " + p, "data-tooltip": t, children: o });
}
export {
  r as Tooltip
};
//# sourceMappingURL=Tooltip.js.map
